import { makeStyles, tokens } from "@fluentui/react-components";

const OVERLAY_Z_INDEX = 1000;

export const useStyles = makeStyles({
  root: {
    position: "fixed",
    inset: 0,
    zIndex: OVERLAY_Z_INDEX,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: tokens.spacingVerticalXXL,
    backgroundColor: tokens.colorNeutralBackgroundAlpha,
    backdropFilter: "blur(2px)",
  },
  card: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalL,
    maxWidth: "360px",
    width: "100%",
    padding: tokens.spacingVerticalXXL,
    borderRadius: tokens.borderRadiusLarge,
    backgroundColor: tokens.colorNeutralBackground1,
    boxShadow: tokens.shadow16,
    textAlign: "center",
  },
  actions: {
    display: "flex",
    justifyContent: "center",
  },
});
